/* Tableau de bord Geotab : mise en page du Tableau de bord principal (DashboardCharts.css), avec sept mesures cliquables. */
.geotab-dash { container: geotab-dash / inline-size; display: grid; min-width: 0; gap: 8px; }
.geotab-dash-body, .geotab-dash-main, .geotab-dash-row, .geotab-dash-trio, .geotab-dash-side { display: grid; min-width: 0; gap: 8px; align-content: start; }
@container geotab-dash (min-width: 1100px) {
  .geotab-dash-row { grid-template-columns: minmax(0, 2fr) minmax(0, 1fr); align-items: stretch; }
  .geotab-dash-trio { grid-auto-flow: column; grid-auto-columns: minmax(0, 1fr); align-items: stretch; }
  .geotab-dash-side { grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; }
}
@container geotab-dash (min-width: 1500px) {
  .geotab-dash-body { grid-template-columns: minmax(0, 1fr) 360px; align-items: start; }
  .geotab-dash-side { grid-template-columns: minmax(0, 1fr); }
}
.geotab-dash-trio > .dashboard-card { display: flex; flex-direction: column; }
.geotab-dash-trio > .dashboard-card > .dashboard-card-body { flex: 1 0 auto; }
.geotab-dash-scroll { max-height: 236px; overflow-y: auto; padding-right: 4px; }

/* Sept cellules sur une ligne ; quatre puis deux colonnes sans case vide quand la place manque. */
.dashboard-kpi-grid.geotab-kpi-grid { grid-template-columns: repeat(7, minmax(0, 1fr)); }
.geotab-kpi-grid > .geotab-kpi-cell {
  appearance: none; border: 0; border-radius: 0; background: #fff; font: inherit; text-align: left; color: inherit; cursor: pointer;
  box-shadow: -1px 0 0 var(--color-slate-200, #e2e8f0), 0 -1px 0 var(--color-slate-200, #e2e8f0);
}
.geotab-kpi-grid > .geotab-kpi-cell:hover { background: var(--color-slate-50, #f8fafc); }
.geotab-kpi-grid > .geotab-kpi-cell[aria-pressed="true"] {
  box-shadow: -1px 0 0 var(--color-slate-200, #e2e8f0), 0 -1px 0 var(--color-slate-200, #e2e8f0), inset 0 -3px 0 var(--color-accent);
}
.geotab-kpi-cell[aria-pressed="true"] .dashboard-kpi-label { color: var(--color-accent); }
.geotab-kpi-cell:focus-visible { outline: 2px solid var(--color-accent); outline-offset: -2px; }
.geotab-kpi-grid .dashboard-kpi-delta { white-space: normal; }
/* Sept cases étroites : la mini-barre passe sous la valeur. */
@container dashboard-kpi-strip (max-width: 1500px) {
  .geotab-kpi-grid .dashboard-kpi-main { flex-direction: column; align-items: stretch; }
  .geotab-kpi-grid .dashboard-kpi-spark { width: 100%; }
}
@container dashboard-kpi-strip (max-width: 1250px) {
  .dashboard-kpi-grid.geotab-kpi-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .geotab-kpi-grid > :first-child { grid-column: span 2; }
}
@container dashboard-kpi-strip (max-width: 760px) {
  .dashboard-kpi-grid.geotab-kpi-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .geotab-kpi-grid > :first-child { grid-column: 1 / -1; }
}

.geotab-dash-legend { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 4px 12px; font-size: 11px; color: var(--color-slate-700, #334155); }
.geotab-dash-legend span { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }
.geotab-dash-legend i { display: inline-block; width: 12px; height: 10px; border-radius: 2px; }
.geotab-dash-legend i[data-shape="line"] { height: 2px; border-radius: 0; }
.geotab-dash-legend i[data-shape="dash"] { height: 0; border-top: 1.5px dashed #64748b; border-radius: 0; }

.dashboard-metric-gauge > span[data-tone="warning"] { background: var(--color-amber); }
.dashboard-metric-row[data-strong] .dashboard-metric-label { font-weight: 700; color: var(--color-slate-900, #0f172a); }

/* Graphique par journée : toute la hauteur de sa carte (étirée par « À surveiller »), au moins 236 px. */
.geotab-dash-chart { display: flex; flex-direction: column; }
.geotab-dash-chart > .dashboard-card-body { position: relative; flex: 1 1 auto; min-height: 236px; }
.geotab-dash-chart .dashboard-chart-scroll { position: absolute; inset: 0; }
@media (max-width: 767px) { .geotab-dash .dashboard-chart-canvas { min-width: var(--geotab-chart-min, 0px); } }

/* Ajusté à la fenêtre (data-fit) : le graphique prend la hauteur qui reste, les listes défilent dans leur carte. */
.geotab-dash-body[data-fit] { overflow: hidden; grid-template-rows: minmax(0, 1fr); }
.geotab-dash-body[data-fit] > .geotab-dash-main { height: 100%; grid-template-rows: minmax(0, 1fr) auto; }
.geotab-dash-body[data-fit] .geotab-dash-row { min-height: 0; grid-template-rows: minmax(0, 1fr); }
.geotab-dash-body[data-fit] .dashboard-watch { display: flex; min-height: 0; flex-direction: column; overflow: hidden; }
.geotab-dash-body[data-fit] .dashboard-watch-list { min-height: 0; flex: 1 1 0; overflow-y: auto; padding-right: 4px; }
.geotab-dash-body[data-fit] > .geotab-dash-main { grid-template-rows: minmax(0, 1fr) 250px; }
.geotab-dash-body[data-fit] .geotab-dash-trio { min-height: 0; grid-template-rows: minmax(0, 1fr); }
.geotab-dash-body[data-fit] .geotab-dash-trio > .dashboard-card { min-height: 0; overflow: hidden; }
.geotab-dash-body[data-fit] .geotab-dash-trio > .dashboard-card > .dashboard-card-body { display: flex; min-height: 0; flex: 1 1 0; flex-direction: column; }
.geotab-dash-body[data-fit] .geotab-dash-trio .dashboard-metric-rows { max-height: none; min-height: 0; flex: 1 1 0; overflow-y: auto; padding-right: 4px; }
.geotab-dash-body[data-fit] > .geotab-dash-side { height: 100%; overflow-y: auto; padding-right: 2px; }
.geotab-dash-body[data-fit] .geotab-dash-side .dashboard-metric-rows > .dashboard-metric-row { padding: 3px 0; }
.geotab-dash-body[data-fit] .dashboard-watch-item { padding: 4px 0; }

/* « Le plan du Dispatch est-il juste ? » : une rangée par étape, l'écart moyen à gauche, prévu et réel par journée à droite. */
.geotab-dash-stages > .dashboard-card-body { display: grid; min-height: 420px; grid-template-rows: repeat(3, minmax(110px, 1fr)); }
.geotab-stage-row { display: grid; min-height: 0; grid-template-columns: 175px minmax(0, 1fr); gap: 12px; border-top: 1px solid #eef2f5; padding-top: 4px; }
.geotab-stage-row:first-child { border-top: 0; padding-top: 0; }
.geotab-stage-head { display: flex; min-width: 0; flex-direction: column; justify-content: center; gap: 2px; font-size: 11px; }
.geotab-stage-gap { font-size: 22px; font-weight: 750; line-height: 1.05; letter-spacing: -0.02em; color: var(--color-slate-900, #0f172a); font-variant-numeric: tabular-nums; }
.geotab-stage-row[data-active] .dashboard-kpi-label { color: var(--color-accent); }
.geotab-dash-plot { position: relative; min-width: 0; min-height: 0; }
@container geotab-dash (max-width: 700px) {
  .geotab-stage-row { grid-template-columns: minmax(0, 1fr); grid-template-rows: auto 130px; }
}
.geotab-dash-body[data-fit] .geotab-dash-stages { overflow: hidden; }
.geotab-dash-body[data-fit] .geotab-dash-stages > .dashboard-card-body { min-height: 0; grid-template-rows: repeat(3, minmax(0, 1fr)); }

/* Ligne survolée ou cliquée d'un tableau Geotab (GeotabPage) : même surlignage qu'au Data Manager.
   Le survol prend le fond plein, au lieu du voile pâle global de app.css ; la ligne cliquée garde en plus sa barre et son contour. */
[data-geotab-page] tbody > tr:has(> td + td):hover > td { background-color: var(--color-legacy-teal-soft); }
tr[data-geotab-row-selected] { outline: 1px solid color-mix(in srgb, var(--color-accent) 45%, transparent); outline-offset: -1px; }
tr[data-geotab-row-selected] > td { background-color: var(--color-legacy-teal-soft); }
tr[data-geotab-row-selected] > td:first-child { box-shadow: inset 3px 0 0 var(--color-accent); }
